module.exports = __webpack_public_path__ + "img/bg-big-schedule.640b685d.png";